import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IResources } from './model';

const selectResourcesFeat = createFeatureSelector<Readonly<IResources>>('resources');
export const selectResources = createSelector(selectResourcesFeat, (resources: IResources) => resources);
export const selectBonus = createSelector(selectResourcesFeat, (resources: IResources) => resources.bonus);
